var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Grid, Box } from "@mui/material";
import FormField from "./FormField";
import SurveyPageHeader from "../../../components/SurveyPageHeader";
import { chunkRow, getItemGridSize, groupElementsIntoRows, useMaxItemsPerRow, } from "../utils/layout-utils";
/**
 * Componente que renderiza uma página do formulário com todos os seus elementos
 */
var FormPage = function (_a) {
    var page = _a.page, errors = _a.errors, showPageTitles = _a.showPageTitles;
    var maxItemsPerRow = useMaxItemsPerRow();
    var logicalRows = groupElementsIntoRows(page.elements);
    return (_jsxs(Box, { children: [showPageTitles && (_jsx(SurveyPageHeader, { title: page.title, description: page.description })), _jsx(Grid, __assign({ container: true, spacing: 2 }, { children: logicalRows.flatMap(function (logicalRow) {
                    return chunkRow(logicalRow, maxItemsPerRow).flatMap(function (visualRow) {
                        return visualRow.map(function (element, index) { return (_jsx(Grid, __assign({ item: true, xs: getItemGridSize(visualRow.length, index === visualRow.length - 1), "data-element-name": element.name }, { children: _jsx(FormField, { element: element, errors: errors }) }), element.name)); });
                    });
                }) }))] }));
};
export default FormPage;
